import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const liveNotificationChannel = defineChannel({
  id: 'live_notification',
  icon: 'mobile',
} as const satisfies ChannelDefinition);
